import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import MultiSelect from './components/multiSelect';

export const Category = ({ onChange, customFilters, data, variant }) => (
  <Flex flexDirection="column" sx={{ gap: 40 }}>
    {customFilters.map((filter) => (
      <Box key={filter.id}>
        <MultiSelect
          onChange={(selected) => onChange('category', { ...data, [filter.name]: selected })}
          label={filter.name}
          options={filter.options}
          initialData={data[filter.name]}
          type="tag"
          key={filter.id}
          variant={variant}
        />
      </Box>
    ))}
  </Flex>
);

Category.propTypes = {
  onChange: PropTypes.func.isRequired,
  customFilters: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

Category.defaultProps = {
  variant: 'onboarding',
};

export default Category;
